import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';

export default function Language({ language }) {
    const {
        name,
        native_name,
        level
    } = language;

    return (
        <li>
            {name}
            &nbsp;{name !== native_name && <strong>({native_name})</strong>}
            &nbsp;- <span><I18n k={`user_page_perseus.seller_profile.language_level.${level}`}/></span>
        </li>
    );
}

Language.propTypes = {
    language: PropTypes.shape({
        name: PropTypes.string,
        native_name: PropTypes.string,
        level: PropTypes.number
    })
};

Language.defaultProps = {
    language: {
        name: '',
        native_name: '',
        level: 0
    }
};
